module.exports = ngRoute;


/*****************
 ** WEBPACK FOOTER
 ** external "ngRoute"
 ** module id = 28
 ** module chunks = 0
 **/